import React from "react";
import { Img } from "../../../Img";
export const NumberedListImageCard = ({ title, content, image }) => (React.createElement("div", { className: "numbered-list-card" },
    React.createElement(Img, { src: image, alt: title }),
    React.createElement("h4", { className: "h4-bold" }, title),
    React.createElement("hr", null),
    React.createElement("div", { className: "numbered-list-card__list", dangerouslySetInnerHTML: { __html: content } })));
